var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistoryDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.915,
    height: 41.255,
    viewBox: "0 0 31.915 41.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.002 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.76,34.17a7.027,7.027,0,0,1,12.046-4.977l2.108-2.109V32.4H26.6l1.931-1.931a5.152,5.152,0,0,0-3.7-1.612A5.314,5.314,0,1,0,28.6,37.926L29.876,39.2A7.114,7.114,0,0,1,17.76,34.17ZM15.035,38h-12A3.045,3.045,0,0,1,0,34.96V3.04A3.044,3.044,0,0,1,3.039,0H15.481V7.6a4.278,4.278,0,0,0,4.277,4.271h9.122V24.766A10.508,10.508,0,0,0,15.035,38h0Zm9.792-10.915h0Zm-2.7-20.124a1.335,1.335,0,0,1-1.337-1.336V.527a.519.519,0,0,1,.52-.52,2.259,2.259,0,0,1,1.449.52L28.127,5a2.08,2.08,0,0,1,.752,1.61.348.348,0,0,1-.352.351Z",
    fill: "#007f0e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryDocument);
export default __webpack_public_path__ + "static/media/history-document.3b73e602314d8f58b8cda844643e2217.svg";
export { ForwardRef as ReactComponent };